import { IKeHoachMonGhepCapActionTypes } from "../../action-types/ke-hoach/IKeHoachMonGhepCapActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { eGhepCapStatusExtend, IKeHoachMonGhepCapReducer } from "../../reducer-model/ke-hoach/IKeHoachMonGhepCapReducer";
const iniState: IKeHoachMonGhepCapReducer = {
  status: eReducerStatusBase.is_not_initialization,
  ghepCaps: [],
  nam_hoc: "",
  hoc_ky: 0,
  filter: {
    // id_chuyen_nganh: 198,
    // id_he: 1,
    // khoa_hoc: 2024,
    // id_nganh: 0
    id_chuyen_nganh: 0,
    id_he: 0,
    khoa_hoc: 0,
    id_nganh: 0
  },
  keHoachMons: [],
  nhomLopIdsExpanded:[]
};
export const keHoachMonGhepCapReducer = (
  state: IKeHoachMonGhepCapReducer = iniState,
  action: IKeHoachMonGhepCapActionTypes
): IKeHoachMonGhepCapReducer => {
  switch (action.type) {
    case "GHEP_CAP_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
        nam_hoc: action.payload.nam_hoc,
        hoc_ky: action.payload.hoc_ky
      };
    case "GHEP_CAP_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        ghepCaps: action.payload,
      };
    case "GHEP_CAP_LOAD_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "GHEP_CAP_SHOW_EDIT_MODAL":
      return {
        ...state,
        ghepCapEditing: action.payload,
        isShowEditModal: true
      };
    case "GHEP_CAP_CLOSE_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: false
      };
    case "GHEP_CAP_SAVE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving
      };
    case "GHEP_CAP_SAVE_SUCCESS":
      const ids = action.payload.map(x => x.id);
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        ghepCaps: [...state.ghepCaps.filter(x=> !ids.includes(x.id)), ...action.payload],
        isShowEditModal: false
      };
    case "GHEP_CAP_SAVE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed
      };
    case "GHEP_CAP_DELETE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_deleting
      };
    case "GHEP_CAP_DELETE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload
      };
    case "GHEP_CAP_DELETE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed
      };
    case "GHEP_CAP_CHANGE_FILTER":
      return {
        ...state,
        filter: action.payload
      };
    case "GHEP_CAP_LOAD_KE_HOACH_MON_START":
      return {
        ...state,
        status: eGhepCapStatusExtend.is_loading_kh
      };
    case "GHEP_CAP_LOAD_KE_HOACH_MON_SUCCESS":
      return {
        ...state,
        status: eGhepCapStatusExtend.is_completed_kh,
        keHoachMons: action.payload
      };
    case "GHEP_CAP_LOAD_KE_HOACH_MON_ERROR":
      return {
        ...state,
        status: eGhepCapStatusExtend.is_completed_kh,
      };
      case "GHEP_CAP_CHANGE_EXPANDED_IDS":
        return {
          ...state,
          nhomLopIdsExpanded: action.payload
        };
    default:
      return state;
  }
};
